(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-carrousel-image"] && !Shopify.designMode) return;
  try {
    
  // No se requiere JavaScript adicional para el scroll horizontal natural.

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-carrousel-video"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const popup   = document.getElementById('videoPopup');
  const swiperE = document.getElementById('popupSwiper');
  const btnX    = document.querySelector('.video-btn-close');
  const btnPrev = document.querySelector('.nav-prev');
  const btnNext = document.querySelector('.nav-next');
  const thumbs  = document.querySelectorAll('.video-thumb');

  function playOnlyActive() {
    const allVideos = swiperE.querySelectorAll('video');
    allVideos.forEach(video => {
      video.pause();
      video.currentTime = 0;
    });

    const activeSlide = swiperE.swiper.slides[swiperE.swiper.activeIndex];
    if (activeSlide) {
      const activeVideo = activeSlide.querySelector('video');
      if (activeVideo) {
        activeVideo.play();
      }
    }
  }

  function openPopup(i = 0) {
    swiperE.innerHTML = '';

    thumbs.forEach(t => t.querySelector('video').pause());

    thumbs.forEach(t => {
      const src = t.querySelector('video source')?.src || t.querySelector('video')?.src;
      const slide = document.createElement('swiper-slide');
      slide.innerHTML = `<video controls playsinline preload="auto"><source src="${src}" type="video/mp4"></video>`;
      swiperE.appendChild(slide);
    });

    popup.style.display = 'flex';

    customElements.whenDefined('swiper-container').then(() => {
      requestAnimationFrame(() => {
        swiperE.swiper?.destroy();
        swiperE.initialize();
        swiperE.swiper.slideTo(i, 0);

        swiperE.swiper.on('slideChange', () => {
          setTimeout(playOnlyActive, 10);
        });

        setTimeout(playOnlyActive, 10);
      });
    });

    btnPrev.onclick = () => swiperE.swiper.slidePrev();
    btnNext.onclick = () => swiperE.swiper.slideNext();
  }

  function closePopup() {
    popup.style.display = 'none';
    swiperE.innerHTML = '';
    thumbs.forEach(t => t.querySelector('video').play());
  }

  thumbs.forEach((t, i) => {
    t.addEventListener('click', () => openPopup(i));
  });

  btnX.addEventListener('click', closePopup);
  popup.addEventListener('click', e => e.target === popup && closePopup());
  document.addEventListener('keydown', e => e.key === 'Escape' && popup.style.display === 'flex' && closePopup());
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inspolook-carousel-v2"] && !Shopify.designMode) return;
  try {
    
  // No se requiere JavaScript adicional para el scroll horizontal natural.

  } catch(e) { console.error(e); }
})();
})();
